export const inputClassNames =
  'peer w-full px-4 pb-2 caret-blue-600 outline-none transition-all font-lato text-base font-normal leading-[1.4rem] text-neutral-950 placeholder:text-neutral-600 focus:ring-2 focus:ring-blue-600 dark:text-neutral-100 h-[56px] rounded-xl border border-neutral-300 bg-inherit hover:border-neutral-500 pt-6 focus:ring-2 focus:ring-blue-600';

export const invalidInputClassNames =
  'peer w-full pb-2 outline-none transition-all font-lato text-base font-normal leading-[1.4rem] text-neutral-950 placeholder:text-neutral-600 focus:ring-2 caret-red-500 focus:ring-red-500 dark:text-neutral-50 h-[56px] rounded-xl px-4 border bg-inherit border-red-500 focus:border-red-500 hover:border-red-700 dark:hover:border-red-400 pt-5';

export const labelClassNames =
  'absolute left-[17px] top-2 font-lato text-xs font-normal leading-[1.05rem] text-neutral-600 transition-all dark:text-neutral-500';

export const captionClassNames =
  'mt-1 pl-4 font-lato text-xs leading-[1.05rem] text-red-500 dark:text-red-400';
